import { CSSProperties } from 'react';

export const imagePlace: CSSProperties = {
  width: '70px',
  height: '70px',
  objectFit: 'cover',
};
